import Fuse from 'fuse.js';
import _ from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import { MultiSelect } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { accountingProviders } from '~/lookups';

export default function AccountingIntegrationFilter({ placeholder = 'Accounting Integration', name, value, onChange }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [data, setData] = useState(null);
  const [options, setOptions] = useState([]);

  const handleSearch = useCallback(
    async (q) => {
      let options = data;
      if (!data) {
        const { data: result } = await api.www.workspaces(workspace.id).integrations().accounting.options({});
        setData(result);
        options = result;
      }
      if (q) {
        options = new Fuse(options, { keys: ['name'], threshold: 0.4, ignoreLocation: true })
          .search(q)
          .map((result) => result.item);
      }
      setOptions(options);
    },
    [workspace.id, api, data],
  );

  const groups = useMemo(() => {
    if (!options) return null;
    return _(options)
      .orderBy((o) => (value?.some((v) => v.id === o.id) ? 0 : 1))
      .groupBy((o) =>
        value?.some((v) => v.id === o.id) ? 'Selected' : accountingProviders[o.provider]?.name || o.provider,
      )
      .value();
  }, [options, value]);

  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      renderOptions={(opts) => {
        const optionsById = _.keyBy(opts, 'id');
        return Object.keys(groups)
          .sort((a, b) => {
            if (a === 'Selected') return -1;
            if (b === 'Selected') return 1;
            return a.localeCompare(b);
          })
          .map((group) => (
            <MultiSelect.Group key={group} label={group}>
              {groups[group].map((option) => (
                <MultiSelect.Option key={option.id} {...optionsById[option.id].props}>
                  {option.name}
                </MultiSelect.Option>
              ))}
            </MultiSelect.Group>
          ));
      }}
      isLoading={!data}
      onSearch={handleSearch}
      onChange={onChange}
    />
  );
}
